import React from 'react';
import { Link } from 'react-router-dom';
import './Media.css';

function Media() {
  const mediaCategories = [
    {
      title: "Digital Publications",
      description: "Access our collection of digital books, articles, and research papers",
      path: "/media/publications",
      icon: "📚"
    },
    {
      title: "Video Gallery",
      description: "Watch historical documentaries and presentations",
      path: "/media/videos",
      icon: "🎥"
    },
    {
      title: "Historical Marker Inventory",
      description: "Explore Harris County's historical markers and their stories",
      path: "/media/markers",
      icon: "📍"
    }
  ];

  return (
    <div className="media">
      <section className="page-hero">
        <h1>Media Library</h1>
        <p>Explore our digital collections and resources</p>
      </section>

      <div className="page-container">
        <div className="media-categories-grid">
          {mediaCategories.map((category, index) => (
            <Link to={category.path} key={index} className="category-card">
              <div className="category-content">
                <span className="category-icon">{category.icon}</span>
                <div className="category-text">
                  <h2>{category.title}</h2>
                  <p>{category.description}</p>
                </div>
              </div>
              <span className="category-arrow">→</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Media; 